import { render, staticRenderFns } from "./ModuleFieldConfigurator.vue?vue&type=template&id=73bcb4f7&scoped=true"
import script from "./ModuleFieldConfigurator.vue?vue&type=script&lang=js"
export * from "./ModuleFieldConfigurator.vue?vue&type=script&lang=js"
import style0 from "./ModuleFieldConfigurator.vue?vue&type=style&index=0&id=73bcb4f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bcb4f7",
  null
  
)

export default component.exports